import { SEND_VERIFY_EMAIL, VERIFY_EMAIL_INVALID_TOKEN } from './types';

export function sendVerifyEmail(token) {
  return { type: SEND_VERIFY_EMAIL, payload: { access_token: token } };
}

export function isInvalidTokenVerifyEmail(invalidTokenVerifyEmail) {
  return {
    type: VERIFY_EMAIL_INVALID_TOKEN,
    payload: { invalidTokenVerifyEmail },
  };
}
